import PropTypes from 'prop-types';
import {
  currencyToPointsJsonSchema,
  currencyToPointsUiSchema
} from '@/services/schema/activity';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {useAppSelector} from '@/store';
import {getCurrencySymbol} from '@/utils/commons';
import {useMemo} from 'react';

const CurrencyToPointsSetUp = ({formData, handleFormChange}) => {
  const countryCode = useAppSelector((state) => state.countryCode).countryCode;
  const localCurrencyCode = useMemo(
    () => getCurrencySymbol(countryCode),
    [countryCode]
  );

  const localCurrencyNum = Number(formData?.localCurrency) || 0;
  const pointsEarnedNum = Number(formData?.pointsEarned) || 0;
  const showPreview = localCurrencyNum > 0 && pointsEarnedNum > 0;

  return (
    <div className='flex items-center gap-4'>
      <JsonFormsWrapper
        jsonschema={currencyToPointsJsonSchema}
        uischema={currencyToPointsUiSchema(localCurrencyCode)}
        data={formData}
        onChange={handleFormChange}
      />
      {showPreview && (
        <div className='flex flex-col gap-1'>
          <span className='text-xs font-bold uppercase text-white'>
            PREVIEW
          </span>
          <span className='whitespace-nowrap text-sm'>
            <span className='font-bold'>{localCurrencyNum}</span>{' '}
            <span className='font-normal'>
              {localCurrencyCode.toUpperCase()}
            </span>{' '}
            <span className='font-bold'>= {pointsEarnedNum}</span>{' '}
            <span className='font-normal'>Points</span>
          </span>
        </div>
      )}
    </div>
  );
};

CurrencyToPointsSetUp.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default CurrencyToPointsSetUp;
